import styled from 'styled-components'

export const TooltipDescription = styled.p`
  font-family: 'Inter';
  text-align: center;
  font-size: 0.875rem;
  line-height: 22px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.zds.colors.neutral1000};
  white-space: break-spaces;
`
